import React, { useState } from 'react';
import { HiOutlineClipboardDocumentCheck, HiOutlineDocumentText } from 'react-icons/hi2';

const Step4_Investigation = ({ incidentData, readOnly = false }) => {
  const [investigation, setInvestigation] = useState(incidentData.investigation || {
    facts: '',
    unsafeAct: '',
    unsafeCondition: '',
    witnessInput: '',
    contributingCause: '',
    immediateActions: ''
  });

  if (!incidentData) return null;

  const handleChange = (field, value) => {
    if (readOnly) return;
    setInvestigation(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="bg-card p-6 rounded-xl border border-gray-200 shadow-sm max-w-4xl mx-auto my-0">
      <div className="border-b border-gray-200 pb-4 mb-6 flex items-start justify-between">
        <div>
          <h2 className="text-md font-bold text-primary flex items-center gap-2">
            <HiOutlineClipboardDocumentCheck className="w-6 h-6 text-purple-600" />
            Detailed Investigation & RCA
          </h2>
          <p className="text-tertiary text-sm mt-1">Document the findings from the investigation team to determine the root cause.</p>
        </div>
      </div>

      <div className="space-y-6">

        {/* Facts & Witness Input */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-2 bg-page-bg/50 p-4 rounded-xl border border-gray-100">
            <label className="text-base   font-semibold text-primary mb-4 flex items-center gap-2">
              <HiOutlineDocumentText className="w-5 h-5 text-tertiary" />
              Facts Gathered
            </label>
            <textarea
              rows={4}
              className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
              value={investigation.facts || ''}
              onChange={(e) => handleChange('facts', e.target.value)}
              readOnly={readOnly}
              placeholder="List objective facts established during the investigation..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Witness Input / Testimonies</label>
            <textarea
              rows={3}
              className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
              value={investigation.witnessInput || ''}
              onChange={(e) => handleChange('witnessInput', e.target.value)}
              readOnly={readOnly}
              placeholder="Summarize statements from witnesses..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Immediate Actions Taken</label>
            <textarea
              rows={3}
              className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
              value={investigation.immediateActions || ''}
              onChange={(e) => handleChange('immediateActions', e.target.value)}
              readOnly={readOnly}
              placeholder="Actions taken immediately after the incident to secure the area or treat injured..."
            />
          </div>
        </div>

        {/* RCA Categorization */}
        <div className="bg-purple-50/50 p-6 rounded-xl border border-purple-100 mt-6">
          <h3 className="text-base font-semibold text-purple-900 uppercase tracking-wider mb-4">Root Cause Categorization</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-secondary mb-1">Unsafe Act(s)</label>
              <textarea
                rows={3}
                className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
                value={investigation.unsafeAct || ''}
                onChange={(e) => handleChange('unsafeAct', e.target.value)}
                readOnly={readOnly}
                placeholder="Identify any actions by personnel that contributed..."
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-secondary mb-1">Unsafe Condition(s)</label>
              <textarea
                rows={3}
                className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
                value={investigation.unsafeCondition || ''}
                onChange={(e) => handleChange('unsafeCondition', e.target.value)}
                readOnly={readOnly}
                placeholder="Identify any physical or environmental conditions that contributed..."
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-secondary mb-1">Primary Root / Contributing Cause</label>
              <textarea
                rows={3}
                className="w-full rounded-md p-2 mt-1 border border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
                value={investigation.contributingCause || ''}
                onChange={(e) => handleChange('contributingCause', e.target.value)}
                readOnly={readOnly}
                placeholder="Summarize the ultimate root cause of this incident..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4_Investigation;
